export default "__VITE_ASSET__aMpJCgnZ__"